
import React, { Fragment } from 'react';
import Dropdown from '../../../core/controls/components/dropdown';
import TextBox from '../../../core/controls/components/textbox';
import MultipleDropdown from '../../../core/controls/components/checkautocomplete';

const extraProps = {
    transformProps: {
        label: 'Name',
        value: 'Id'
    },
}

const domainProps = {
    transformProps: {
        label: 'Name',
        value: 'Value'
    },
}



export default function MPSApplicationProperties({ handleFieldChange, loadFieldsData, state }) {

    return <Fragment>
        <div className='row col-12'>
            {/* <Dropdown className="col-3" extraProps={extraProps} items={state.sitepermittype || []} handleFieldValue={handleFieldChange} value={state.SITE_PERMIT_TYPE_ID} label={state.subModuleKey === "INQUIRIES" ? 'Inquiry Type' : 'Permit Type'} name='SITE_PERMIT_TYPE_ID' />
            {state.SITE_PERMIT_TYPE_ID && state.subModuleKey === "INQUIRIES" && state.inquirysubtype.length > 0 && <Dropdown name='REQUEST_TYPE' className="col-3  m-2" value={state.REQUEST_TYPE} handleFieldValue={handleFieldChange} label={'Request Type'}
                items={state.inquirysubtype || []} extraProps={domainProps} />} */}
            <Dropdown className="col-3 county" extraProps={extraProps} items={state.applicationsite || []} handleFieldValue={handleFieldChange} value={state.SITE_ID} label={'County'} name={'SITE_ID'} disabled={true} />
            <Dropdown className="col-3 region" extraProps={extraProps} items={state.applicationregion || []} handleFieldValue={handleFieldChange} value={state.REGION_ID} label={'Region'} name={'REGION_ID'} disabled={true} />
            {state.SITE_PERMIT_TYPE_ID && state.subModuleKey === "CONNECTIONS" && <Dropdown name='PROPOSED_ACTIVITY_HEADER' className="col-3" value={state.PROPOSED_ACTIVITY_HEADER} handleFieldValue={handleFieldChange} required={true} label={'Proposed Activity'}
                items={state.proposedactivityitems || []} extraProps={domainProps} />}
        
            {state.SITE_PERMIT_TYPE_ID && state.subModuleKey === "WHROW" && <MultipleDropdown name='WORK_TYPE' className="col-6 worktype" ismulti={true} value={state.WORK_TYPE}
                handleFieldValue={(e) => {
                    console.log(e)
                    handleFieldChange(e)
                }} required={true} label={'Work Type'}
                items={state.worktypeitems || []} extraProps={domainProps} />}

        </div>

        <div className='row mb-1'>
            {state.SITE_PERMIT_TYPE_ID && state.subModuleKey === "CONNECTIONS" && <MultipleDropdown name='ALTER_EXISTING_ACTIVITIES_HEADER' error={state.haserror} helperText={state.validationmsg} className="col-12" disabled={state.disablealter} ismulti={true} value={state.ALTER_EXISTING_ACTIVITIES_HEADER} handleFieldValue={handleFieldChange} required={state.isalterrequired} label={'Alter existing Activities'}
                items={state.alteractivitiesitems || []} extraProps={extraProps} />}
        </div>
        {/* <Dropdown disabled={state.disable} className="col-2" extraProps={domainProps} items={state.townvillagecity || []} handleFieldValue={handleFieldChange} value={state.townvillagecityvalue} label={'Town/Village/City'} name={'TOWN_VILLAGE_CITY'} />
            <TextBox  disabled={state.disable}className="col-2" extraProps={domainProps} items={state.interstatehwy|| []} handleFieldValue={handleFieldChange} value={state.interstatehwyvalue} label={'Interstate/Hwy'} name={'INTERSTATE_HWY'} /> */}

    </Fragment>
}


//value={((state.applicationregion || []).find(each => String(each.Id) === String(state.REGION_ID)) || {}).Name}